import { DOCUMENT, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { CARDNET_ENV, CARDNET_FORM_ID, CARDNET_KEY } from './cardnet.tokens';

declare const PWCheckout: any;

type CardnetConfig = {
  env: string;
  key: string;
  formId?: string;
};

export function provideCardnet(config: CardnetConfig) {
  const formId = config.formId ?? crypto.randomUUID();
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const document = inject(DOCUMENT);

      const script = document.createElement('script');
      script.setAttribute('id', 'PWCheckout');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', `${config.env}/Scripts/PWCheckout.js?key=${config.key}`);
      script.async = true;
      script.defer = true;
      script.onload = () => {
        if (PWCheckout?.Bind) {
          PWCheckout.Bind('tokenCreated', (...args: any[]) =>
            console.log('PWCheckout/tokenCreated', args),
          );
          PWCheckout.Bind('opened', (...args: any[]) => console.log('PWCheckout/opened', args));
          PWCheckout.Bind('closed', (...args: any[]) => console.log('PWCheckout/closed', args));
        }
      };
      document.head.appendChild(script);

      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('id', 'PWToken');
      input.setAttribute('name', 'PWToken');

      const form = document.createElement('form');
      form.setAttribute('id', formId);
      form.appendChild(input);

      document.body.appendChild(form);
    }),
    {
      provide: CARDNET_ENV,
      useValue: config.env,
    },
    {
      provide: CARDNET_KEY,
      useValue: config.key,
    },
    {
      provide: CARDNET_FORM_ID,
      useValue: formId,
    },
  ]);
}
